export default __webpack_public_path__ + "static/media/Siloam-hospital-logo.bb3a5804.png";